import {getUrlParam, wsPrefix} from "../urlParams";
import {VcmpClient} from "@variocube/vcmp";
import {Logger} from "@variocube/driver-common";
import {EventSource} from "../EventSource";

const thisUnit = getUrlParam("unit");

export function isThisUnit(unit?: string) {
    return !thisUnit || thisUnit == unit;
}

const log = new Logger("unit");

export const unit = new class {

    private readonly client;

    public readonly connected = new EventSource<boolean>();
    public readonly status = new EventSource<UnitStatus>();

    constructor() {
        const client = new VcmpClient(`${wsPrefix()}://localhost:2000`, {
            autoStart: true
        });
        client.onOpen = () => {
            log.info("Unit connection open");
            this.connected.safeInvokeListeners(true);
        }
        client.onClose = () => {
            log.info("Unit connection closed");
            this.connected.safeInvokeListeners(false);
        }
        client.on("unit:Status", (status: UnitStatus) => {
            log.info("Received unit status", status);
            this.status.safeInvokeListeners(status);
        })
        this.client = client;
    }
}

export interface UnitStatus {
    id: string;
    connected: boolean;
    lastConnected?: number;
    boot: number;
    setup: string | false;
    packages: Record<PackageName, PackageInfo>;
}

export type PackageName = string;
export type PackageConfig = string;

export interface PackageInfo {
    installed?: string;
    available: string[];
    hold: boolean;
    config: PackageConfig;
}
